import axios from 'axios'

const baseURL = process.env.VUE_APP_SERVICE_URL

const request = (url, params = {}, config = {}) => {
  return new Promise((reslove, reject) => {
    axios.request({
      url,
      method: config.method || 'post',
      baseURL: config.baseURL || baseURL,
      // headers: {
      //   'X-CSRF-TOKEN': global.CSRF_TOKEN
      // },
      responseType: config.responseType || null,
      params: config.method === 'get' ? params : null,
      data: config.method !== 'get' ? params : null,
    }).then(response => {
      const data = response.data
      if (response.status === 200) {
        if (config.noCode || data.code === 1) {
          reslove(data)
          // 成功提示
          if (config?.successMsg) {
            // typeof config.successMsg === 'string' ? this.message.success(config.successMsg) : this.message.success(res.description)
          }
        } else {
          reject(data)
        }
      } else {
        reject(response)
      }
    }).catch(error => {
      reject(error)
    })
  })
}



export {
  request
}
